import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useEffectOnce } from "@lib-shared/hooks";
import { BusinessPage } from "core/constants";
import { useUpdatePage } from "core/hooks";
import User, { getUser } from "core/models/user";
import { Notice } from "components/common-ui";

function AccountCreatedConfirmation() {
    const [updateTitle,] = useUpdatePage();
    const [isValidUser, setIsValidUser] = useState<boolean | null>(null);
    const hasExecuted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);

    const failureUrl = BusinessPage.accountNotFound;
    const [successUrl, setSuccessUrl] = useState(BusinessPage.dashboard);

    // const location = window.location;
    const navigate = useNavigate();

    // const searchParams = new URLSearchParams(location.search);

    // const action = searchParams.get("action");

    const handleSignInFailure = () => {
        setIsValidUser(false);
        navigate(failureUrl, { replace: true });
    }

    const getUserDetails = () => {
        if (isValidUser || !isLoading || hasExecuted.current) {
            return;
        }

        hasExecuted.current = true;

        const user = User.instance ?? getUser();

        if (user?.company?.customerNumber != null) {
            if (user?.hasMultipleCompanies ?? false) {
                setSuccessUrl(BusinessPage.chooseCompany);
            }

            setIsValidUser(true);
            setIsLoading(false);
            return;
        }

        console.error("Error getting user", JSON.stringify(user));
        handleSignInFailure();
    };

    const redirectToSuccessPage = () => navigate(successUrl, { replace: true });

    //if (action == ApplicationAction.campaignSignIn) {
    useEffectOnce(() => {
        document.body.classList.remove("link-up-customer");
        getUserDetails();

        // Use for testing
        // setIsValidUser(true);
        // setIsLoading(false);
    });
    //}

    // if (action == ApplicationAction.campaignSignUp) {
    // }

    useEffect(() => {
        const title = isLoading
            ? "Please wait..."
            : isValidUser
                ? "Account Created" : "";
        updateTitle(title);
    })

    if (isLoading) {
        return (
            <Notice showSpinner={true}>
                <p>
                    Please wait while we finish creating your account.
                </p>
            </Notice>
        );
    }

    if (isValidUser === true) {
        return (
            <Notice>
                <i className="result-icon icon-tick"></i>

                <h1>Account Created</h1>

                <p>
                    Your account has been<br />
                    successfully created.
                </p>

                <button className="btn btn-black" onClick={redirectToSuccessPage}>Done</button>
            </Notice>
        );
    }

    return null;
}

export default AccountCreatedConfirmation;
